module.exports = __webpack_public_path__ + "band_6.50299dfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_6.png
// module id = gjq7
// module chunks = 0